<br />

<!-- <div class="toggle">
  <mat-slide-toggle (change)="toggleMapView()">Table View</mat-slide-toggle>
</div> -->

<p class="title">
 Sailing Performance 
  <mat-icon class="titleIcon">chevron_right</mat-icon> Commercial
  Performance<mat-icon class="titleIcon">chevron_right</mat-icon> Fleet
  Performance
</p>
<div class="container">
  <!-- //voyage (weather) -->
  <div class="graph-container">
    <div #firstChartContainer [chart]="graphChart1" class="graphId"></div>
  </div>

  <!-- //voyage (Speed) -->
  <div class="graph-container">
    <div #secondChartContainer [chart]="graphChart2" class="graphId"></div>
  </div>

  <div class="graph-container">
    <div #fiveChartContainer [chart]="graphChart5" class="graphId"></div>
  </div>
  <div class="graph-container">
    <div #sixChartContainer [chart]="graphChart6" class="graphId"></div>
  </div>

  <div class="graph-container">
    <div #thirdChartContainer [chart]="graphChart3" class="graphId"></div>
  </div>

  <div class="graph-container">
    <div #sevenChartContainer [chart]="graphChart7" class="graphId"></div>
  </div>

  <div class="graph-container" style="margin-bottom: 120px">
    <div #sevenChartContainer [chart]="graphChart8" class="graphId"></div>
  </div>
  <br />
</div>
